import styled from "@emotion/styled";
import {mq} from "@styles/helpers";
import {Devices} from "@styles/tokens";


export const CustomGrid = styled.div`
    grid-column: auto / span 2;
    position: relative;
    order: 1;

    ${mq(Devices.laptop)}{
        grid-column: auto / span 4;  
        grid-column-start: 1;
        grid-row-start: 1;
    }

    ${mq(Devices.tablet)}{
        grid-column: auto / span 2;

    }
`;